/* global TradeInValuations */
// FLOW IV

import React from "react"
import PropTypes from "prop-types"
import ThankYouMessage from "./ThankYouMessage"
import LeadForm from "./LeadForm"
import TradeInResult from "./TradeInResult"
import { trackFunction } from "website_script/lib/iframeTrackingHelper"

const FlowValuationOrLeadFormWhenValuationFails = ({
  displayValuation,
  leadSent,
  carSummaryHtml,
  leadFormHtml,
  removeThankYouCheckmark,
  thankYouTextWhenNoValuation,
  thankYouAdditionalText,
  tradeInResult,
  replacementCarSearch,
  handleEditReplacementCar,
  onLeadFormFieldValuesCaptured,
  leadFormFieldValues,
  leadFormStrings,
}) => (
  <div>
    {displayValuation ? (
      <div>
        <TradeInResult
          {...tradeInResult}
          carSummaryHtml={carSummaryHtml}
          trackFunction={trackFunction}
        />
      </div>
    ) : !leadSent ? (
      <LeadForm
        leadFormHtml={leadFormHtml}
        onEditReplacementCar={handleEditReplacementCar}
        replacementCar={replacementCarSearch.preselectedCarInfo}
        onFieldValuesCaptured={onLeadFormFieldValuesCaptured}
        fieldValues={leadFormFieldValues}
        strings={leadFormStrings}
        trackFunction={trackFunction}
      />
    ) : (
      <div>
        <div dangerouslySetInnerHTML={{ __html: carSummaryHtml }} />
        <ThankYouMessage
          text={thankYouTextWhenNoValuation}
          additionalText={thankYouAdditionalText}
          removeThankYouCheckmark={removeThankYouCheckmark}
        />
      </div>
    )}
  </div>
)

FlowValuationOrLeadFormWhenValuationFails.propTypes = {
  displayValuation: PropTypes.bool,
  leadSent: PropTypes.bool,
  carSummaryHtml: PropTypes.string,
  tradeInResult: PropTypes.object,
  leadFormHtml: PropTypes.string,
  thankYouTextWhenNoValuation: PropTypes.string,
  thankYouAdditionalText: PropTypes.string,
  removeThankYouCheckmark: PropTypes.bool,
  replacementCarSearch: PropTypes.object,
  handleEditReplacementCar: PropTypes.func,
  onLeadFormFieldValuesCaptured: PropTypes.func,
  leadFormFieldValues: PropTypes.array,
  leadFormStrings: PropTypes.object,
}

export default FlowValuationOrLeadFormWhenValuationFails
